import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { AppConfigService } from '../../app-config.service';

@Injectable({ providedIn: 'root' })
export class AccessDashboardGuard {
  constructor(private readonly configService: AppConfigService, private readonly router: Router) {}

  canActivate(): boolean | UrlTree {
    return this.configService.config.userCanAccessDashboard ? true : this.router.createUrlTree(['/access-denied']);
  }
}
